import { Row, Table } from 'antd';
import moment from 'moment';
import { memo } from 'react';

import ModalWrap from '@/components/ModalWrap';
import TableAdmin from '@/components/TableAdmin';
import { numberFormatWithComma } from '@/util/numberFormatWithComma';
import './style.scss';
import { formatNumberMoney } from '@/util/formatNumberMoney';

interface IProps {
    isVisible: boolean;
    data: any;
    onCancel: (isVisible: boolean) => void;
}
const Detail: React.FC<IProps> = ({ isVisible, onCancel, data }) => {
    const sales = data;

    const columns = [
        {
            title: 'STT',
            dataIndex: 'no',
            width: '70px',
        },
        {
            title: 'SẢN PHẨM',
            dataIndex: 'origin',
            render: (origin: any) => {
                return origin?.name;
            },
        },
        {
            title: 'Giá bán',
            dataIndex: 'unitPrice',
            align: 'right',
            render: (value: any) => formatNumberMoney(value) + ' ₫',
        },
        {
            title: 'Số lượng',
            align: 'center',
            dataIndex: 'num',
            width: '70px',
        },
        {
            title: 'Thành tiền',
            align: 'right',
            render: (data: any) => {
                return formatNumberMoney(data.num * data.unitPrice) + ' ₫';
            },
        },
        {
            title: 'Cập nhật lúc',
            align: 'center',
            render: (data: any) => {
                return moment(data?.updatedAt ?? data?.createdAt).format('HH:mm:ss DD/MM');
            },
        },
    ];

    return (
        <ModalWrap
            visible={isVisible}
            onCancel={() => onCancel(!isVisible)}
            footer={<></>}
            title={'CHI TIẾT ĐẶT PHÒNG'}
        >
            <div className="p-revenue-content__detail">
                <div className="title">THÔNG TIN PHÒNG ĐÃ ĐẶT</div>
                <div className="table-text">
                    <div className="col">
                        <div className="row">
                            <span className="detail_item">ID đơn hàng</span>
                            <span className="value">{sales?._id}</span>
                        </div>
                        <div className="row">
                            <span className="detail_item">Tên phòng</span>
                            <span className="value bold">
                                {sales?.phong?.roomNo}
                                {sales?.chuyenphong
                                    ? ` (Đổi từ ${sales.chuyenphong?.oldPhong?.roomNo} lúc ${moment(
                                          sales?.chuyenphong?.thoigian,
                                      ).format('HH:mm:ss DD/MM')})`
                                    : ''}
                            </span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="row">
                            <span className="detail_item">CC Căn cước</span>
                            <span className="value">{sales?.cccmnd ? 'CÓ' : 'KHÔNG'}</span>
                        </div>
                        <div className="row">
                            <span className="detail_item">khách hàng</span>
                            <span className="value">{sales?.tenkhachhang ?? ''}</span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="row">
                            <span className="detail_item">Giờ nhận phòng</span>
                            <span className="value">{moment(sales?.starttime).format('HH:mm:ss DD/MM/YYYY')}</span>
                        </div>
                        <div className="row">
                            <span className="detail_item">Giờ trả phòng</span>
                            <span className="value">
                                {sales?.endtime ? moment(sales?.endtime).format('HH:mm:ss DD/MM/YYYY') : ''}
                            </span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="row">
                            <span className="detail_item">Qua đêm</span>
                            <span className="value">{sales?.quadem ? 'CÓ' : 'KHÔNG'}</span>
                        </div>
                        <div className="row">
                            <span className="detail_item">Thời gian sử dụng</span>
                            <span className="value">{sales?.thoigiansudung}</span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="row">
                            <span className="detail_item">Tiền phòng tự động</span>
                            <span className="value">{formatNumberMoney(sales?.tienphongtudong) + ' ₫'}</span>
                        </div>
                        <div className="row">
                            <span className="detail_item">Tiền phòng chỉnh sửa</span>
                            <span className="value">{formatNumberMoney(sales?.tienphong) + ' ₫'}</span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="row">
                            <span className="detail_item">Tiền dịch vụ</span>
                            <span className="value">{formatNumberMoney(sales?.tiendichvu) + ' ₫'}</span>
                        </div>
                        <div className="row">
                            <span className="detail_item">Tiền thực thu</span>
                            <span className="value bold">{formatNumberMoney(sales?.tienthu) + ' ₫'}</span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="row">
                            <span className="detail_item">Tình trạng phòng</span>
                            <span className="value bold">
                                {!sales?.status ? '' : sales?.status === 1 ? 'ĐANG THUÊ' : 'ĐÃ THANH TOÁN'}
                            </span>
                        </div>
                        <div className="row">
                            <span className="detail_item">Ghi chú</span>
                            <span className="value">{sales?.ghichu}</span>
                        </div>
                    </div>
                </div>
                <div className="title">THÔNG TIN DỊCH VỤ</div>
                <TableAdmin
                    columns={columns}
                    data={data?.dichvu ?? []}
                    bordered
                    rowKey="itemId"
                    pointer
                    scroll={{ x: 'max-content' }}
                    className="table_floor table_floor_history"
                    summary={() => {
                        return (
                            <>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell align="center" index={0} colSpan={3} className="total-cell">
                                        {'TỔNG CỘNG'}
                                    </Table.Summary.Cell>

                                    <Table.Summary.Cell index={1}>
                                        <Row justify="center">
                                            <strong>{sales?.soluongdichvuOrder}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={2}>
                                        <Row justify="end">
                                            <strong>{formatNumberMoney(sales?.tiendichvu) + ' ₫'}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                </Table.Summary.Row>
                            </>
                        );
                    }}
                />
            </div>
        </ModalWrap>
    );
};

export default memo(Detail);
